module.exports = __webpack_public_path__ + "static/img/shuizhu.776844b3.png";